import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mobileFirstCss } = mediaQueryStyles;
const { fontFamily, fontSize, heading4 } = typographyStyles;
const [, size] = heading4;
const { textS } = fontSize;
const lightGrey100 = constants.colors.ui.neutral[100];
const neutral500 = constants.colors.ui.neutral[500];
const neutral700 = constants.colors.ui.neutral[700];
const core700 = constants.colors.ui.core[700];
const white = constants.colors.ui.white[700];

export const tab = [
  mobileFirstCss({
    marginRight: ["8px", "48px", "32px"],
    fontWeight: ["normal", "bold"],
    fontSize: [textS.fontSize, size.fontSize],
    lineHeight: [1.7, 1.2],
    color: neutral500,
    borderBottom: "2px solid transparent",
    textDecoration: "none",
    "&:hover": {
      color: neutral700,
    },
  }),
  fontFamily.circular,
];

export const tabActive = [
  ...tab,
  {
    fontWeight: "bold",
    color: neutral700,
    borderBottom: `2px solid ${core700}`,
  },
];

export const ulWrapperCss = mobileFirstCss({
  padding: ["0 8px", "0 40px", "0 40px", "0 80px"],
  whiteSpace: "nowrap",
  display: "flex",
  borderBottom: `1px solid ${lightGrey100}`,
  backgroundColor: white,
  overflow: "auto",
  listStyle: "none",
  marginTop: "0px",
});
